export const Types = {
  // Step
  SET_REGISTER_STEP: "promo/SET_REGISTER_STEP",

  // Nurseries
  GET_NURSERIES: "promo/GET_NURSERIES",
  GET_NURSERIES_SUCCESS: "promo/GET_NURSERIES_SUCCESS",
  GET_NURSERIES_FAIL: "promo/GET_NURSERIES_FAIL",

  // Intrests
  GET_INTERESTS: "promo/GET_INTERESTS",
  GET_INTERESTS_SUCCESS: "promo/GET_INTERESTS_SUCCESS",
  GET_INTERESTS_FAIL: "promo/GET_INTERESTS_FAIL",

  // Send Register
  SEND_REGISTER: "promo/SEND_REGISTER",
  SEND_REGISTER_SUCCESS: "promo/SEND_REGISTER_SUCCESS",
  SEND_REGISTER_FAIL: "promo/SEND_REGISTER_FAIL",
  RESET_SEND_REGISTER: "promo/RESET_SEND_REGISTER",

  // Products & Tips
  GET_PAT: "promo/GET_PAT",
  GET_PAT_SUCCESS: "promo/GET_PAT_SUCCESS",
  GET_PAT_FAIL: "promo/GET_PAT_FAIL",

  // Validate user cpf
  GET_EXISTING_USER: "promo/GET_EXISTING_USER",
  GET_EXISTING_USER_SUCCESS: "promo/GET_EXISTING_USER_SUCCESS",
  GET_EXISTING_USER_FAIL: "promo/GET_EXISTING_USER_FAIL",

  // Send Register
  SEND_REGISTER_PURCHASE: "promo/SEND_REGISTER_PURCHASE",
  SEND_REGISTER_PURCHASE_SUCCESS: "promo/SEND_REGISTER_PURCHASE_SUCCESS",
  SEND_REGISTER_PURCHASE_FAIL: "promo/SEND_REGISTER_PURCHASE_FAIL",
  RESET_SEND_REGISTER_PURCHASE: "promo/RESET_SEND_REGISTER_PURCHASE",
  RESET_PURCHASE_STATE: "promo/RESET_PURCHASE_STATE",


  // Get Purshase
  GET_LIST_PURCHASE: "promo/GET_LIST_PURCHASE",
  GET_LIST_PURCHASE_SUCCESS: "promo/GET_LIST_PURCHASE_SUCCESS",
  GET_LIST_PURCHASE_FAIL: "promo/GET_LIST_PURCHASE_FAIL",

  // Set raffle
  SET_RAFFLE: "promo/SET_RAFFLE",
  SET_RAFFLE_SUCCESS: "promo/SET_RAFFLE_SUCCESS",
  SET_RAFFLE_FAIL: "promo/SET_RAFFLE_FAIL",
  RESET_RAFFLE: "promo/RESET_RAFFLE",

  // Get winners
  GET_WINNERS: "promo/GET_WINNERS",
  GET_WINNERS_SUCCESS: "promo/GET_WINNERS_SUCCESS",
  GET_WINNERS_FAIL: "promo/GET_WINNERS_FAIL",

  // Get products
  GET_PRODUCTS: "promo/GET_PRODUCTS",
  GET_PRODUCTS_SUCCESS: "promo/GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAIL: "promo/GET_PRODUCTS_FAIL",

  // Get sellers
  GET_SELLERS: "promo/GET_SELLERS",
  GET_SELLERS_SUCCESS: "promo/GET_SELLERS_SUCCESS",
  GET_SELLERS_FAIL: "promo/GET_SELLERS_FAIL",

  // link gift
  SEND_LINK_GIFT: "promo/SEND_LINK_GIFT",
  SEND_LINK_GIFT_SUCCESS: "promo/SEND_LINK_GIFT_SUCCESS",
  SEND_LINK_GIFT_FAIL: "promo/SEND_LINK_GIFT_FAIL",

  // get gift
  GET_GIFT: "promo/GET_GIFT",
  GET_GIFT_SUCCESS: "promo/GET_GIFT_SUCCESS",
  GET_GIFT_FAIL: "promo/GET_GIFT_FAIL",

  // get faq
  GET_FAQ: "promo/GET_FAQ",
  GET_FAQ_SUCCESS: "promo/GET_FAQ_SUCCESS",
  GET_FAQ_FAIL: "promo/GET_FAQ_FAIL",

  // get winners
  GET_LIST_WINNERS: "promo/GET_LIST_WINNERS",
  GET_LIST_WINNERS_SUCCESS: "promo/GET_LIST_WINNERS_SUCCESS",
  GET_LIST_WINNERS_FAIL: "promo/GET_LIST_WINNERS_FAIL",
};

export const Creators = {
  // Step
  setRegisterStep: (data) => ({
    type: Types.SET_REGISTER_STEP,
    payload: data,
  }),

  // Nurseries
  getNurseries: () => ({ type: Types.GET_NURSERIES }),
  getNurseriesSuccess: (data) => ({
    type: Types.GET_NURSERIES_SUCCESS,
    payload: data,
  }),
  getNurseriesFail: (data) => ({
    type: Types.GET_NURSERIES_FAIL,
    payload: data,
  }),

  // Interests
  getInterests: () => ({ type: Types.GET_INTERESTS }),
  getInterestsSuccess: (data) => ({
    type: Types.GET_INTERESTS_SUCCESS,
    payload: data,
  }),
  getInterestsFail: (data) => ({
    type: Types.GET_INTERESTS_FAIL,
    payload: data,
  }),

  // Send Register
  sendRegister: (data) => ({ type: Types.SEND_REGISTER, payload: data }),
  sendRegisterSuccess: (data) => ({
    type: Types.SEND_REGISTER_SUCCESS,
    payload: data,
  }),
  sendRegisterFail: (data) => ({
    type: Types.SEND_REGISTER_FAIL,
    payload: data,
  }),
  resetSendRegister: () => ({ type: Types.RESET_SEND_REGISTER }),

  // Products & Tips
  getPAT: () => ({ type: Types.GET_PAT }),
  getPATSuccess: (data) => ({ type: Types.GET_PAT_SUCCESS, payload: data }),
  getPATFail: () => ({ type: Types.GET_PAT_FAIL }),

  getExistingUser: (data) => ({ type: Types.GET_EXISTING_USER, payload: data }),
  getExisingUserFail: (data) => ({
    type: Types.GET_EXISTING_USER_FAIL,
    payload: data,
  }),
  getExistingUserSuccess: (data) => ({
    type: Types.GET_EXISTING_USER_SUCCESS,
    payload: data,
  }),

  // Send Register Purchase
  sendRegisterPurchase: (data) => ({
    type: Types.SEND_REGISTER_PURCHASE,
    payload: data,
  }),
  sendRegisterPurchaseSuccess: (data) => ({
    type: Types.SEND_REGISTER_PURCHASE_SUCCESS,
    payload: data,
  }),
  sendRegisterPurchaseFail: (data) => ({
    type: Types.SEND_REGISTER_PURCHASE_FAIL,
    payload: data,
  }),
  resetSendRegisterPurchase: () => ({
    type: Types.RESET_SEND_REGISTER_PURCHASE,
  }),
  resetPurchaseState: () => ({
    type: Types.RESET_PURCHASE_STATE,
  }),

  // Get list purchase
  getListPurchase: (data) => ({ type: Types.GET_LIST_PURCHASE, payload: data }),
  getListPurchaseSuccess: (data) => ({
    type: Types.GET_LIST_PURCHASE_SUCCESS,
    payload: data,
  }),
  getListPurchaseFail: (data) => ({
    type: Types.GET_LIST_PURCHASE_FAIL,
    payload: data,
  }),

  // Get list purchase
  setRaffle: (data) => ({ type: Types.SET_RAFFLE, payload: data }),
  setRaffleSuccess: (data) => ({
    type: Types.SET_RAFFLE_SUCCESS,
    payload: data,
  }),
  setRaffleFail: (data) => ({
    type: Types.SET_RAFFLE_FAIL,
    payload: data,
  }),
  resetRaffle: () => ({
    type: Types.RESET_RAFFLE,
  }),

  // Get PRODUCTS
  getProducts: () => ({ type: Types.GET_PRODUCTS }),
  getProductsSuccess: (data) => ({
    type: Types.GET_PRODUCTS_SUCCESS,
    payload: data,
  }),
  getProductsFail: (data) => ({
    type: Types.GET_PRODUCTS_FAIL,
    payload: data,
  }),

  // Get SELLER
  getSellers: () => ({ type: Types.GET_SELLERS }),
  getSellersSuccess: (data) => ({
    type: Types.GET_SELLERS_SUCCESS,
    payload: data,
  }),
  getSellersFail: (data) => ({
    type: Types.GET_SELLERS_FAIL,
    payload: data,
  }),

  // set link gift
  setLinkGift: (data) => ({ type: Types.SEND_LINK_GIFT, payload: data }),
  setLinkGiftSuccess: (data) => ({
    type: Types.SEND_LINK_GIFT_SUCCESS,
    payload: data,
  }),
  setLinkGiftFail: (data) => ({
    type: Types.SEND_LINK_GIFT_FAIL,
    payload: data,
  }),

  // set link gift
  getGift: () => ({ type: Types.GET_GIFT }),
  getGiftSuccess: (data) => ({
    type: Types.GET_GIFT_SUCCESS,
    payload: data,
  }),
  getGiftFail: (data) => ({
    type: Types.GET_GIFT_FAIL,
    payload: data,
  }),

  // set faq
  getFaq: () => ({ type: Types.GET_FAQ }),
  getFaqSuccess: (data) => ({
    type: Types.GET_FAQ_SUCCESS,
    payload: data,
  }),
  getFaqFail: (data) => ({
    type: Types.GET_FAQ_FAIL,
    payload: data,
  }),

  // set list winners
  getListWinners: () => ({ type: Types.GET_LIST_WINNERS }),
  getListWinnersSuccess: (data) => ({
    type: Types.GET_LIST_WINNERS_SUCCESS,
    payload: data,
  }),
  getListWinnersFail: (data) => ({
    type: Types.GET_LIST_WINNERS_FAIL,
    payload: data,
  }),
};
